import { render, staticRenderFns } from "./VideoSelector.vue?vue&type=template&id=a664bf66&scoped=true"
import script from "./VideoSelector.vue?vue&type=script&lang=js"
export * from "./VideoSelector.vue?vue&type=script&lang=js"
import style0 from "./VideoSelector.vue?vue&type=style&index=0&id=a664bf66&prod&scoped=true&lang=scss"
import style1 from "./VideoSelector.vue?vue&type=style&index=1&id=a664bf66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a664bf66",
  null
  
)

export default component.exports